//React
import React from "react";

//Material-ui
import Box from '@material-ui/core/Box';

//JSON
var personalityItem = require('../data/personality.json');



const Card = (props) => {
  let primary;
  let secondary;
  let backgroundColor;
  let borderColor;
  let title;
  let subTitle;
  let titleBackgroundColor;
  if (props.level === 'main') {
    title = '主要';
    subTitle = '主要な指向で強く外部に現れる';
    titleBackgroundColor = '#B86E00'
    borderColor = '#B86E00'
    backgroundColor = "#FFE7C2";
  }
  else if (props.level === 'bad') {
    title = '苦手'
    subTitle = '意識するとストレスになる';
    titleBackgroundColor = '#073E77'
    borderColor = '#073E77'
    backgroundColor = "#A6BDD5";
  }
  else if (props.level === 'supply') {
    title = '補完';
    subTitle = 'この能力がある人から補完する';
    titleBackgroundColor = '#920056';
    borderColor = '#920056'
    backgroundColor = "#E7B0D0";
  }
  else if (props.level === 'control') {
    title = '制限';
    subTitle = '備わっているが自制している';
    titleBackgroundColor = '#75AC00';
    borderColor = '#75AC00'
    backgroundColor = "#E4F7BC";
  }

  primary = personalityItem.element.find(item => item.type === props.primary);
  secondary = personalityItem.element.find(item => item.type === props.secondary);

	return (
    <div style={{margin:'10px'}}>
  		<Box
        className='round12'
        boxShadow={2}
        style={{
          background:backgroundColor,
          borderStyle:'solid',
          borderWidth:'1px',
          borderColor:borderColor,
          padding:'10px',
        }}
      >
        {
          (primary && secondary) &&
          <div>
            <span className='text_icon' style={{background: titleBackgroundColor, color:'#FFF'}}>
              {title}
            </span>&nbsp;
            <span style={{color: borderColor}}>
              {subTitle}
            </span>
            <div>{ primary.text}</div>
            <div>{ secondary.text}</div>
          </div>
        }
  		</Box>
    </div>
	)
}


class Comp extends React.Component {


  render() {
    return (
      <div style={{padding:'10px'}}>
        <h2 align='center'>性格エレメント</h2>
        <div align='center'>指向の組み合わせから生じる性格</div>

        <Card
          level='main'
          primary={this.props.element1}
          secondary={this.props.element2}
        />
        <Card
          level='bad'
          primary={this.props.element3}
          secondary={this.props.element4}
        />
        <Card
          level='supply'
          primary={this.props.element5}
          secondary={this.props.element6}
        />
        <Card
          level='control'
          primary={this.props.element7}
          secondary={this.props.element8}
        />

      </div>
    )
  }
}

export default Comp;
